import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "eraser-all",
  "use": "eraser-all-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" class=\"icon icon-tabler icon-tabler-eraser-all\" viewBox=\"0 0 24 24\" id=\"eraser-all\"><path stroke=\"none\" d=\"M0 0h24v24H0z\" /><path d=\"M20.41 19H6l-4-4a1 1 0 0 1 0-1.41l10-10a1 1 0 0 1 1.41 0l5 5a1 1 0 0 1 0 1.41l-9 9\" /><path d=\"M15 3.6a1 1 0 0 1 1.41 0l5 5a1 1 0 0 1 .41 1.4l-9 9M16 12.3 9.7 6M19.254 12.437l-1.63-1.616\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol